"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApolloCache = exports.CACHE_OPTION = void 0;
const core_1 = require("@apollo/client/core");
exports.CACHE_OPTION = {
    typePolicies: {
        Order: {
            fields: {
                isEdited: {
                    read(isEdited = false) {
                        return isEdited;
                    },
                },
                lastSyncedEventId: {
                    read(cachedValue, { readField }) {
                        return cachedValue || readField('prevEventId') || 'unknown';
                    },
                    merge(existing, incoming, { readField }) {
                        return (incoming || existing || readField('prevEventId') || 'unknown');
                    },
                },
            },
        },
        OrderTable: {
            keyFields: false,
        },
        ProductModifierGroup: {
            keyFields: false,
        },
        ProductPricing: {
            keyFields: false,
        },
        Page: {
            keyFields: false,
        },
        PricingGroup: {
            keyFields: false,
        },
        Adjustment: {
            keyFields: false,
        },
        Modifier: {
            keyFields: ['id', 'price', 'isDefault'],
        },
        OrderItemModifier: {
            keyFields: ['id', 'modifierGroupId', 'quantity'],
        },
        ModifierPricingGroup: {
            keyFields: false,
        },
        OrderItem: {
            keyFields: ['id', 'status'],
        },
        RolePermissions: {
            keyFields: false,
        },
    },
};
let cache;
const getApolloCache = (config) => {
    if (!cache) {
        cache = new core_1.InMemoryCache(config !== null && config !== void 0 ? config : exports.CACHE_OPTION);
    }
    return cache;
};
exports.getApolloCache = getApolloCache;
//# sourceMappingURL=apolloClient.js.map